"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _validationContext = require("./validation-context");
var _richTextInput = _interopRequireDefault(require("./rich-text-input"));
var _reactDate = _interopRequireDefault(require("react-date"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// can be passed a `message` to display top right of input
// can be passed a `messageType` of Error, Success, Info, Warning which controls colour (defaults to info)
var _ref = /*#__PURE__*/_react.default.createElement(_validationContext.ValidationError, null);
var _ref2 = /*#__PURE__*/_react.default.createElement(_validationContext.ValidationError, null);
class Input extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      valid: true,
      value: null,
      message: null
    });
    _defineProperty(this, "_onChangeRichText", value => {
      // richtext does not enforce maxLength out of the box so check here
      if (this.props.maxLength && value && value.__html.length > this.props.maxLength) {
        return this.setState({
          valid: false,
          message: 'Maximum Length Exceeded',
          value
        });
      }
      this.setState({
        valid: true,
        value,
        message: null
      });
      this.props.onChange(value, this.props.name);
    });
    _defineProperty(this, "_onChange", e => {
      let value = e.target.value;
      switch (this.props.type) {
        case 'Integer':
          if (value === '') {
            value = null;
          } else if (/^[0-9]*$/.test(value)) {
            value = +value;
          } else {
            return this.setState({
              valid: false,
              message: 'Must be an integer',
              value
            });
          }
          break;
        // urls lower case, numbers and hyphens only, no odd chars
        case 'URL':
          if (!/^[0-9a-z-]*$/.test(value)) {
            return this.setState({
              valid: false,
              message: 'Use lower case letters, numbers and hyphens only',
              value
            });
          }
          break;
        // database will not accept empty string as a date
        case 'Date':
          if (value === '') {
            value = null;
          }
          break;
        // database will not accept empty string as a time
        case 'Time':
          if (value === '') {
            value = null;
          } else {
            // if user entering slightly off but predictable info
            // lets try and guess what they meant
            if (/^\d:$/.exec(value)) {
              if (+value.charAt(0) > 5) {
                value = '0' + value.charAt(0) + value.substr(1);
              } else value = 12 + +value.charAt(0) + value.substr(1);
            } else if (/^\d{2}$/.exec(value) && +value > 23) {
              if (+value.charAt(0) > 5) {
                value = '0' + value.charAt(0) + ':' + value.charAt(1);
              } else value = 12 + +value.charAt(0) + ':' + value.charAt(1);
            } else if (/^\d{3}\d?$/.exec(value)) {
              value = value.substr(0, 2) + ':' + value.substr(2);
            }
            const match = /^(\d\d?):?(\d\d?)?:?(\d\d?)?$/.exec(value);
            if (!match || match[1] && +match[1] > 23 || match[2] && +match[2] > 59 || match[3] + match[3] > 59 || /\d{3}/.exec(value)) {
              return this.setState({
                message: 'Time must be in format HH:MM:SS using 24hr clock',
                messageType: 'Error',
                valid: false,
                value
              });
            }
          }
          break;
        case 'Checkbox':
          value = e.target.checked;
          break;
        case 'UpperCase':
          if (value === '') {
            value = null;
          } else {
            value = value.toUpperCase();
          }
          break;
        case 'Year':
          if (value === '') {
            value = null;
          } else if (!/^[0-9]*$/.test(value) || !(value.length === 2 || value.length === 4)) {
            return this.setState({
              valid: false,
              value
            });
          }
          break;
        case 'Sponsor':
          // commas in the sponsor field cause problems when results are loaded into ranking
          // database so just replace with slashes
          value = value.replace(/,/gi, '/');
          break;
        default:
          if (value === '') {
            value = null;
          }
          break;
      }
      // Could set message as "required" but this is going to be pretty obvious and as it
      // causes tables to move around the preventing of leaving the field is sufficient.
      if ((value === null || value === '') && this.props.required) {
        return this.setState({
          valid: false,
          value
        });
      }
      this.setState({
        valid: true,
        message: null,
        value: null
      });
      this.props.onChange(value, this.props.name);
    });
    _defineProperty(this, "focus", () => {
      if (this._input) {
        this._input.focus();
      } else {
        this._focusPending = true;
      }
    });
    _defineProperty(this, "_setRef", input => {
      if (input) {
        if (this._focusPending) {
          input.focus();
          this._focusPending = false;
        }
        this._updateCustomValidity(input);
      }
      this._input = input;
    });
    _defineProperty(this, "_updateCustomValidity", input => {
      if (input.setCustomValidity) {
        if (this.props.messageType === 'Error' || !this.state.valid) {
          // If the messageType is error or invalid then setCustomValidity will prevent
          // `onSubmit` from firing in forms
          input.setCustomValidity(this.state.message || this.props.message);
        } else {
          // setting validity to the empty string removes the validation error
          input.setCustomValidity('');
        }
      }
    });
  }
  componentDidUpdate() {
    if (this._input) {
      this._updateCustomValidity(this._input);
    }
  }
  render() {
    // identify any props that will not be passed down
    // and extract those that will so that we don't pass down props
    // which will be unknown in the standard DOM element.
    const {
      message,
      messageType,
      customValidation,
      customValidationType,
      setInput,
      suffix,
      enabled,
      prefix,
      validationMessages,
      isValid,
      ...props
    } = this.props;
    const propsClasses = props.className || '';
    let inputClass = this.state.valid ? '' : 'has-danger';
    let messageClass = this.state.valid ? '' : 'text-danger text-xs-right';
    if (!messageClass && message) {
      switch (messageType) {
        case 'Error':
          messageClass = 'text-danger text-xs-right';
          inputClass = 'has-danger';
          break;
        case 'Warning':
          messageClass = 'text-warning text-xs-right';
          inputClass = 'has-warning';
          break;
        case 'Success':
          messageClass = 'text-success text-xs-right';
          inputClass = 'has-success';
          break;
        default:
          messageClass = 'text-info text-xs-right';
          break;
      }
    }
    const _value = this.state.valid ? props.value : this.state.value;
    const value = _value === null || _value === undefined ? '' : _value;
    switch (props.type) {
      case 'Checkbox':
        props.type = 'checkbox';
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "form-check"
        }, !(messageType === 'Error' || !this.state.valid) ? null : _ref, /*#__PURE__*/_react.default.createElement("input", _extends({}, props, {
          checked: props.checked,
          onChange: this._onChange,
          ref: this._setRef
        })), props.label ? /*#__PURE__*/_react.default.createElement("span", null, " ", props.label) : null);
      case 'Radio':
        props.type = 'radio';
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "form-check"
        }, /*#__PURE__*/_react.default.createElement("input", _extends({}, props, {
          checked: props.checked,
          value: value,
          onChange: this._onChange,
          ref: this._setRef
        })), ' ', props.label);
      case 'Time':
        props.type = 'text';
        props.placeholder = 'HH:MM:SS';
        break;
      case 'Integer':
      case 'Year':
        props.type = 'tel';
        break;
      case 'UpperCase':
      case 'Sponsor':
      case 'URL':
        props.type = 'text';
        break;
      default:
        break;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: inputClass
    }, !(this.state.message || message) ? null : /*#__PURE__*/_react.default.createElement("p", {
      className: messageClass,
      style: {
        marginBottom: '0'
      }
    }, this.state.message || message), !(messageType === 'Error' || !this.state.valid) ? null : _ref2, props.type === 'RichText' ? /*#__PURE__*/_react.default.createElement(_richTextInput.default, _extends({}, props, {
      value: value,
      className: "form-control",
      onChange: this._onChangeRichText
    })) : props.type === 'Date' ? /*#__PURE__*/_react.default.createElement(_reactDate.default, _extends({}, props, {
      type: "text",
      format: "DD/MM/YYYY",
      placeholder: "DD/MM/YYYYY",
      className: 'form-control ' + propsClasses,
      value: value,
      onChange: this._onChange,
      inputRef: this._setRef
    })) : props.type === 'TextArea' ? /*#__PURE__*/_react.default.createElement("textarea", _extends({}, props, {
      value: value,
      onChange: this._onChange,
      className: 'form-control ' + propsClasses,
      ref: this._setRef
    })) : /*#__PURE__*/_react.default.createElement("span", {
      className: "input-group"
    }, !prefix ? null : /*#__PURE__*/_react.default.createElement("span", {
      className: "input-group-addon"
    }, prefix), /*#__PURE__*/_react.default.createElement("input", _extends({}, props, {
      value: value,
      onChange: this._onChange,
      className: 'form-control ' + propsClasses,
      ref: this._setRef
    })), !suffix ? null : /*#__PURE__*/_react.default.createElement("span", {
      className: "input-group-addon"
    }, suffix || '')));
  }
}
exports.default = Input;